import React, { useState, useEffect } from 'react';
import { Element, animateScroll as scroll } from 'react-scroll';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Biography from './components/Biography';
import Careers from './components/Careers';
import Expertise from './components/Expertise';
import BackToTopButton from './components/BackToTopButton';
import Contact from './components/Contact';

function App() {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="relative h-[100%]">
      <div className="background">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div className="z-10 flex flex-col justify-center align-center items-center relative">
        <Navbar />
        <Element name="hero" className='w-full flex justify-center'>
          <Hero />
        </Element>
        <Element name="biography" className='w-full flex justify-center'>
          <Biography />
        </Element>
        <Element name="careers" className='w-full flex justify-center'>
          <Careers />
        </Element>
        <Element name="expertise" className='w-full flex justify-center'>
          <Expertise />
        </Element>
        <Element name="contact" className='w-full flex justify-center'>
          <Contact />
        </Element>
      </div>
      {showBackToTop && <BackToTopButton />}
    </div>
  );
}

export default App;
